<template>
  <div>
    <Article :pageType="2"></Article>
  </div>
</template>

<script>


export default {
  name: "articleList",
  components: {
    Article: () => import("@/view/article/list"),
  },
};
</script>
